import { makeAutoObservable, reaction } from 'mobx';
import agent from '../agents';
import { navigate } from 'gatsby-link';

export default class UserStore {
    tokenKey = 'hailcx-admin-app-token';
    token: string | null = null;
    authenticationError = '';

    constructor() {
        makeAutoObservable(this);

        reaction(
            () => this.token,
            token => {
                if (token) {
                    sessionStorage.setItem(this.tokenKey, token);
                } else {
                    sessionStorage.removeItem(this.tokenKey);
                }
            }
        );
    }
    setToken = (token: string | null) => {
        this.token = token;
    };
    get isLoggedIn() {
        if (!!this.token) return true;
        else {
            this.setToken(sessionStorage.getItem(this.tokenKey));
            return !!this.token;
        }
    }
    resetSession = () => {
        this.setAuthenticationError('');
        this.setToken(null);
        sessionStorage.removeItem(process.env.GATSBY_LSK_HAILCX_ADMIN_APP_TOKEN ?? this.tokenKey);
    };

    logout = () => {
        this.resetSession();
        navigate('/');
    };
    validateUser = async (username: string, password: string) => {
        try {
            // Reset state
            this.resetSession();

            // get token by username and password
            const token = await agent.Identity.adminLogin(username, password);

            if (token) {
                // Token return and hence user is successfully logged in
                this.setToken(token);
                sessionStorage.setItem(process.env.GATSBY_LSK_HAILCX_ADMIN_APP_TOKEN ?? this.tokenKey, token);
            } else {
                this.setAuthenticationError('An error occurred. Please check the username and password and try again.');
            }
        } catch (error) {
            console.log(error);
            this.setAuthenticationError('An error occurred. Please check the username and password and try again.');
        }
    };

    setAuthenticationError = (error: string) => {
        this.authenticationError = error;
    };
}
